import React, { useEffect, useState } from 'react';
import Scheduler from '../../components/Scheduler/index';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { createSchedule, getSchedule, toggleUpdateMode, updateSchedule, cancelSchedule, confirmSchedule, onValueChange } from '../../services/create_schedule/actions';
import DateRangeIcon from '@material-ui/icons/DateRange';
import InviteForm from './InviteForm';
import NotificationModal from './../../components/NotificationModal/index';
import ConfirmationPopup from '../../components/ConfirmationPopup/index';
import actionConstants from '../../services/create_schedule/constants';
import PagePreloader from '../../components/PagePreloader/index';
import { SuccessMessage, InfoMessage } from '../../components/Messages/index';
import ActionButton from '../../components/ActionButton/index';
import { getSchedulesJSON, hasEmptyDays, getSanitizedSchedule } from '../../services/scheduler/utils';
import ContactForm from '../../components/ContactForm/index';
import ContactInfo from '../../components/ContactInfo/index';
import AddressModal from '../../components/AddressForm/AddressModal';
import { setAddress } from '../../services/scheduler/actions';
import { Grid, TextField } from '@material-ui/core/';

const CreateSchedule = (props) => {
    const {
        receiver,
        specialInstructions,
        sentAt,
        bookedAt,
        eventName,
        isUpdateMode,
        isCancelMessageVisible,
        buyerSchedules,
        isSuccesMessageVisible: isModalVisible,
        pending,
        isBooked,
        sellerEmail,
        sellerName,
        sellerPhone,
        sellerPhoneExtension,
        buyerName,
        buyerPhone,
        buyerPhoneExtension,
        eventAddress,
        city,
        state,
        zipcode
    } = useSelector((state) => state.scheduleCreationData);
    const eventId = props.match.params.guid;
    const schedule = useSelector(state => state.scheduler.schedule);
    const address = useSelector(state => state.scheduler.address);
    const activeDay = useSelector(state => state.scheduler.activeDateSlot)
    const [cancelOpened, toggleCancelModalState] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');
    const [isSubmitted, setSubmitFlag] = useState(false);
    const [instructions, setInstructions] = useState('');
    const [name, setName] = useState('');

    const hasSomeSlots =
        Object.values(schedule)
            .some(el =>  el.length);

    const dispatch = useDispatch();

    useEffect(() => {
        getSchedule(eventId)(dispatch);
    }, [eventId, dispatch])

    useEffect(() => {
        if (hasEmptyDays(schedule)) {
            setWarningMessage('You have not selected time slots for some of your available dates.');
        } else {
            setWarningMessage('');
        }
    }, [schedule])

    const getCustomTimeslots = () => {
        if (!buyerSchedules) return null;
        const schedule = getSanitizedSchedule(buyerSchedules);
        return schedule[activeDay] || [];
    }

    const getContactInfo = () => {
        const info = {};
        if (sellerName) {
            info.sellerName = sellerName;
        }

        if (sellerPhone) {
            info.sellerPhone = sellerPhone;
        }
        if (sellerPhoneExtension) {
            info.sellerPhoneExtension = sellerPhoneExtension;
        }
        return info;
    };

    const onChange = (name) => (value) => {
        if (name == "sellerName") {
            setName('');
            value = value.replace(/[^A-Z a-z]/ig, '')
        }
        else if (name == "sellerPhoneExtension") {
            value = value.replace(/[^0-9 ()+]/ig, '')
        }
       
        dispatch(onValueChange({ name, value }))
       
    };

    const handleSubmit = (formData = {}) => { 
        if (sellerName) {
            const requestData = {
                schedules: getSchedulesJSON(schedule),
                receiver: receiver || formData.email,
                specialInstructions: instructions || specialInstructions || formData.instructions,
                eventId,
                address,
                eventAddress: eventAddress,
                city: city,
                state: state,
                zipcode: zipcode,
                isSellerUpdate: true,
                ...getContactInfo()
            }

            if (buyerSchedules) {
                const { date, time } = getSchedulesJSON(schedule)[0] || {};
                const requestData = {
                    datetime: (new Date(`${date} ${time[0].split(' ')[0]}`)).toISOString(),
                    buyerEmail: receiver,
                    eventId,
                    schedules: getSchedulesJSON(schedule),
                    userSelectedDatetime: moment(date + " " + time[0].split(' ')[0]).format("MM/DD/YYYY HH:mm")
                }
                confirmSchedule(requestData)(dispatch);
                return;
            }

            setSubmitFlag(true);
            if (hasEmptyDays(schedule)) return;

            if (isUpdateMode) {
                updateSchedule(requestData)(dispatch);
            } else {
                createSchedule(requestData)(dispatch);
            }
        }
        else {
            setName("This field is required")
        }        
    }

    const handleCancel = () => {
        cancelSchedule({ eventId: eventId, isSeller: true, isBuyer: null })(dispatch);
        toggleCancelModalState(false);
    };

    const getReadOnlyOptions = () => {
        return receiver && { receiver, specialInstructions }
    }

    const isReadOnlyMode = () => {
        return (!isUpdateMode && receiver)
            || isBooked;
    }

    const handleChange = (flag) => {
        dispatch(toggleUpdateMode(flag));
    }

    const commonChange = (name, value, event) => {
        if (name === "zipcode") {
           // let isZipcode = /^[0-9 -]*$/
           value= value.replace(/[^0-9-]/ig, '')
            dispatch(onValueChange({ name, value }))
            //if (isZipcode.test(value) || value === "") {
            //    dispatch(onValueChange({ name, value }))
            //}
            //else {
            //    value = (zipcode === undefined || zipcode === null ? "" : zipcode);
            //    dispatch(onValueChange({ name, value}))
                
            //}
        }
        else if (name === "city" || name === "state") {
            let isCityOrState = /^[a-zA-Z]+$/
            value = value.replace(/[^a-zA-Z]/ig, '');
            dispatch(onValueChange({ name, value }))
            //value.replace(/[^0-9-]/ig, '')
            //if (isCityOrState.test(value) || value === "" ) {
            //    dispatch(onValueChange({ name, value }))
            //}
        }
        else {
            dispatch(onValueChange({ name, value }))
        }

    }

    const contactFormRenderer = () => {
        return (
            <>
                {
                    //<div style={{ display: "none" }}>
                    //    <AddressModal
                    //        handleSubmit={(data) => dispatch(setAddress(data))}
                    //        defaultAddress={address}
                    //        disabled={(!isUpdateMode && receiver) && !isBooked}
                    //        readOnly={isBooked}
                    //    />
                    //</div>
                }
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <TextField id="address"
                            name="eventAddress"
                            value={eventAddress}
                            onChange={(e) => commonChange(e.target.name, e.target.value, e)}
                            label="Address"
                            variant="outlined"
                            inputProps={{ maxLength: 200 }}
                            disabled={!!isReadOnlyMode()}
                            className="w-100" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField id="city"
                            name="city"
                            value={city}
                            onChange={(e) => commonChange(e.target.name, e.target.value, e)}
                            label="City"
                            variant="outlined"
                            disabled={!!isReadOnlyMode()}
                            className="w-100" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField id="state"
                            name="state"
                            value={state}
                            onChange={(e) => commonChange(e.target.name, e.target.value, e)}
                            label="State"
                            variant="outlined"
                            inputProps={{ maxLength: 100 }}
                            disabled={!!isReadOnlyMode()}
                            pattern="[a-z A-Z]"
                            className="w-100" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {console.log("zipcode", zipcode)}
                        <TextField
                            id="zipcode"
                            name="zipcode"
                            value={zipcode ? zipcode : ""}
                            onChange={(e) => commonChange(e.target.name, e.target.value, e)}
                            label="Zipcode"
                            variant="outlined"
                            inputProps={{ maxLength: 11 }}
                            disabled={!!isReadOnlyMode()}
                            className="w-100" />
                    </Grid>
                </Grid>

                {
                    !buyerSchedules && !isBooked && (
                        <ContactForm
                            name={sellerName}
                            setName={onChange('sellerName')}
                            phone={sellerPhone}
                            setPhone={onChange('sellerPhone')}
                            setExtension={onChange('sellerPhoneExtension')}
                            extension={sellerPhoneExtension}
                            disabled={!!isReadOnlyMode()}
                            error={name}
                        />
                    )
                }
            </>
        );
    };


    const renderSubmitForm = () => {
        let inactiveMessage = '';
        //if (!address) {
        //    inactiveMessage = 'Please select an address';
        //}
        if (!hasSomeSlots) {
            inactiveMessage = 'Please select your available hours';
        }
        return (
            <InviteForm
                isUpdateMode={isUpdateMode}
                readOnlyOptions={getReadOnlyOptions()}
                onSubmit={handleSubmit}
                inactiveMessage={inactiveMessage}
                onInstructionsChange={isUpdateMode ? setInstructions : undefined}
                warningMessage={isSubmitted && warningMessage}
                additionalFieldsRenderer={contactFormRenderer}
                sellerEmail={sellerEmail}
            />
        );
    }

    const renderPageActions = () => {
        if (isBooked) return null;

        if (!isUpdateMode && !buyerSchedules) return null;

        return (
            <div className='page-actions'>
                {buyerSchedules && (
                    <ActionButton
                        onClick={handleSubmit}
                        title='Confirm'
                        disableError={(!hasSomeSlots && 'Please select your available hours')}
                    />
                )}
                {isUpdateMode && (
                    <ActionButton
                        disableError={(!hasSomeSlots && 'Please select your available hours') || warningMessage}
                        onClick={handleSubmit}
                        title='Send update'
                    />
                )}
                <ActionButton onClick={() => toggleCancelModalState(true)} title='Cancel appointment' />
            </div>
        );
    }

    const getSuccessMessage = () => {
        return isUpdateMode
            ? `${eventName} was successfully updated.`
            : `Invite for ${eventName} has been successfully sent.`
    }

    const getTitle = () => {
        if (isBooked) {
            return (
                <span>
                    Scheduled Date/Time
        </span>
            );
        }
        if (buyerSchedules) {
            return (
                <span>
                    Confirm proposed Date/Time or cancel appointment
        </span>
            );
        }
        return isUpdateMode
            ? 'Updating an Appointment'
            : 'Start Scheduling';
    }

    if (pending) {
        return <PagePreloader />;
    }

    return (
        <div className='page create-schedule'>
            {isBooked && (
                <SuccessMessage
                    title={
                        <span>{eventName} appointment was successfully scheduled</span>
                    }
                />
            )}
            <div className='page-bar'>
                <h3 className='page-title'><DateRangeIcon /> {getTitle()}</h3>
                {renderPageActions()}
            </div>
            {!isReadOnlyMode() && <h3 className='page-title page-title__descr'>Select Dates and Times Available</h3>}

            <Scheduler
                readOnly={(isReadOnlyMode() && !buyerSchedules) || isBooked}
                submitSenderer={renderSubmitForm}
                customTimeSlots={getCustomTimeslots()}
                hoursMultiselect={!buyerSchedules}
                IsSeller={true}
                buyerSchedules={buyerSchedules}
            />

            {isBooked && (
                <div style={{ marginBottom: '15px' }}>
                    <ActionButton onClick={() => toggleCancelModalState(true)} title='Cancel appointment' />
                </div>
            )}

            <div className='scheduler'>
                <div className='scheduler__left'>
                    <ContactInfo
                        title='Buyer Contact Information'
                        email={receiver}
                        name={buyerName}
                        phone={buyerPhone}
                        extension={buyerPhoneExtension}
                    />
                </div>
            </div>

            {receiver && !buyerSchedules && !isBooked && (
                <InfoMessage
                    logger
                    title={(
                        <span>
                            Notification was sent to {receiver} on {moment(moment.utc(sentAt).toDate()).local().format('MM/DD/YYYY hh:mm A')}
                            &nbsp;with availability details.
              {!isUpdateMode && (
                                <span>
                                    &nbsp;If you wish to change availability schedule or cancel the appointment,&nbsp;
                  <span onClick={() => handleChange(true)} className='changer-link' href='#'>click here</span>.
                </span>
                            )}
                        </span>
                    )}
                />
            )}

            {isBooked && (
                <InfoMessage
                    logger
                    title={(
                        <span>
                            Email Notification with {eventName} appointment details was sent to {sellerEmail} on {moment(moment.utc(bookedAt).toDate()).local().format('MM/DD/YYYY HH:mm A')}.

                           
            </span>
                    )}
                />
            )}

            <NotificationModal
                titleRenderer={() => (
                    <SuccessMessage
                        title={`${eventName} was successfully canceled.`}
                    />
                )}
                descriptionRenderer={() => (
                    <div className='notification-description'>
                        Buyer ({receiver}) will receive email notification.
          </div>
                )}
                isOpened={isCancelMessageVisible}
            />


            <NotificationModal
                titleRenderer={() => (
                    <SuccessMessage
                        title={getSuccessMessage()}
                    />
                )}
                descriptionRenderer={() => (
                    <div className='notification-description'>
                        Buyer ({receiver}) will receive email notification.
          </div>
                )}
                isOpened={isModalVisible}
                //isOpened={true}
                handleClose={() => {
                    handleChange(false);
                    dispatch({ type: actionConstants.HIDE_SCHEDULE_CREATION_SUCCESS_MESSAGE })
                }}
            />

            <ConfirmationPopup
                title={'Confirm cancellation'}
                description={'Are you sure you want to cancel this appointment?'}
                handleConfirm={handleCancel}
                handleClose={() => toggleCancelModalState(false)}
                opened={cancelOpened}
            />
        </div>
    )
}

export default CreateSchedule;